/**
 * Accepts a list and returns a comma-delimited string.
 * If the list is longer than the (optional) cutoff, the last N items are omitted and '(+N)' is appended to the string.
 * @param list
 * @param cutoff
 */
const listToString = (list: (string | boolean)[], cutoff?: number) => {
  if (cutoff && list.length > cutoff) {
    const shortenedList = list.slice(0, cutoff);

    return `${shortenedList.join(', ')} (+${list.length - cutoff})`;
  }

  return list.join(', ');
};

export default listToString;
